import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { roleHome, APP_LOGO } from "@/lib/constants";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [msg, setMsg] = useState("Memverifikasi akun Google Anda...");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const search = new URLSearchParams(location.search || window.location.search || "");
    const err = search.get("error") || new URLSearchParams(hash.replace(/^#/, "")).get("error");
    if (err) { toast.info("Login Google dibatalkan. Silakan coba lagi."); navigate("/login", { replace: true }); return; }
    if (!sid) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        localStorage.setItem("primrose_token", data.access_token);
        window.location.assign(roleHome(data.user.role));
      } catch (err) {
        const detail = formatApiError(err.response?.data?.detail);
        toast.info(detail, { duration: 8000 });
        navigate("/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <div className="flex flex-col items-center gap-4 text-center px-6">
        <img src={APP_LOGO} alt="Primrose Organizer" className="h-24 w-auto object-contain" />
        <Loader2 className="w-6 h-6 text-burgundy animate-spin" />
        <p className="text-sm text-[#7A7A7A]" data-testid="google-callback-msg">{msg}</p>
      </div>
    </div>
  );
}
